/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";

// Material Dashboard 2 PRO React helper functions
// import rgba from "assets/theme-dark/functions/rgba";
import pxToRem from "assets/theme-dark/functions/pxToRem";
import linearGradient from "assets/theme-dark/functions/linearGradient";
import { keepColor } from "assets/theme-dark/darkColorAdapter";

const { white, gradients, info, transparent } = colors;

const trackOff = "#334155";
const trackOffBorder = "#475569";
const { borderWidth } = borders;
const { md } = boxShadows;

const switchButton = {
  defaultProps: {
    disableRipple: false,
  },

  styleOverrides: {
    switchBase: {
      color: gradients.dark.main,

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-checked": {
        color: info.main,

        "&:hover": {
          backgroundColor: transparent.main,
        },

        "& .MuiSwitch-thumb": {
          borderColor: `${info.main} !important`,
        },

        "& + .MuiSwitch-track": {
          backgroundColor: `${info.main} !important`,
          borderColor: `${info.main} !important`,
          opacity: 1,
        },
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: "0.3 !important",
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        backgroundImage: linearGradient(
          gradients.info.main,
          gradients.info.state,
        ),
      },
    },

    thumb: {
      backgroundColor: keepColor(white.main),
      boxShadow: md,
      border: `${borderWidth[1]} solid ${trackOffBorder}`,
    },

    track: {
      width: pxToRem(32),
      height: pxToRem(15),
      backgroundColor: trackOff,
      border: `${borderWidth[1]} solid ${trackOffBorder}`,
      opacity: 1,
    },

    checked: {},
  },
};

export default switchButton;
